module.exports = __webpack_public_path__ + "static/3-378486c6e97e8b6f9c037d10a9b648f4.png";